import React from "react";

import EntityPage from "~/pages/Editor/EditorCatalogEducationalPrograms/EntityPage";
import { LevelsManagement } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorLevels/LevelsManagement";
import { useGetLevelsData } from "~/pages/Editor/EditorCatalogEducationalPrograms/hooks";
import { getCurriculumColumns } from "~/pages/Editor/EditorCatalogEducationalPrograms/model/tableAdapter";
import { levelsTableHeader } from "~/pages/Editor/EditorCatalogEducationalPrograms/options";

const EditorLevels = () => (
  <EntityPage
    titleKey="cep.levels"
    createPermission="employeeAccounting.curriculum.level.create"
    updatePermission="employeeAccounting.curriculum.level.update"
    tableHeader={levelsTableHeader}
    getColumns={getCurriculumColumns("cep.levels_table")}
    useData={useGetLevelsData}
    Management={LevelsManagement}
    formId="LevelForm"
    editTitleKey="cep.edit_level"
    addTitleKey="cep.add_level"
  />
);

export default EditorLevels;
